export default async function ({commit, dispatch, getters}) {
    commit('loading', true);
    await dispatch('list/get', getters['list/form/data']);
    commit('loading');
}